// Appointment Date + Start/End selects (`_appointment_schedule_fields.html`).
// - Today / Tomorrow / In 2 days / Next Monday chips use the browser's today.
// - End follows Start (+60 min) until someone picks an End, and End options at
//   or before Start are disabled so the end can never precede the start.
// - Initial values come from the wrapper: stored instants on Edit appointment
//   (shown in the browser's timezone), or the submitted values after a refusal.
//   A time not on the 15-minute grid is added as its own option so saving
//   never moves it.
(function () {
    const pad = (value) => String(value).padStart(2, '0');

    function isoDate(date) {
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    }

    function toMinutes(value) {
        const [hours, minutes] = value.split(':').map(Number);
        return hours * 60 + minutes;
    }

    function fromMinutes(total) {
        return `${pad(Math.floor(total / 60))}:${pad(total % 60)}`;
    }

    function timeLabel(value) {
        const total = toMinutes(value);
        const hours = Math.floor(total / 60);
        return `${(hours + 11) % 12 + 1}:${pad(total % 60)} ${hours < 12 ? 'AM' : 'PM'}`;
    }

    // Select `value`, inserting it in time order when it is off the grid.
    function selectTime(select, value) {
        if (!value) return;
        let option = Array.from(select.options).find((opt) => opt.value === value);
        if (!option) {
            option = new Option(timeLabel(value), value);
            const before = Array.from(select.options).find(
                (opt) => opt.value && toMinutes(opt.value) > toMinutes(value),
            );
            select.add(option, before || null);
        }
        select.value = value;
    }

    function quickDate(chip) {
        const day = new Date();
        const offset = chip.dataset.appointmentDateOffset === 'next-monday'
            ? (8 - day.getDay()) % 7 || 7
            : Number(chip.dataset.appointmentDateOffset);
        day.setDate(day.getDate() + offset);
        return isoDate(day);
    }

    function syncChips(root) {
        const dateInput = root.querySelector('[data-appointment-date]');
        root.querySelectorAll('[data-appointment-date-offset]').forEach((chip) => {
            const active = dateInput.value === quickDate(chip);
            chip.classList.toggle('chip-primary', active);
            chip.classList.toggle('chip-muted', !active);
        });
    }

    // Disable End options at or before Start; move End to Start + 60 when it
    // is no longer after Start, or when End has not been picked by hand.
    function syncEnd(root, { followStart }) {
        const start = root.querySelector('[data-appointment-start]');
        const end = root.querySelector('[data-appointment-end]');
        const startMinutes = start.value ? toMinutes(start.value) : null;
        Array.from(end.options).forEach((opt) => {
            opt.disabled = Boolean(opt.value) && startMinutes !== null && toMinutes(opt.value) <= startMinutes;
        });
        if (startMinutes === null) return;
        const endBeforeStart = end.value && toMinutes(end.value) <= startMinutes;
        if (followStart || endBeforeStart) {
            selectTime(end, fromMinutes(Math.min(startMinutes + 60, 23 * 60 + 45)));
        }
    }

    function init(root) {
        if (root.dataset.appointmentTimeFieldsReady) return;
        root.dataset.appointmentTimeFieldsReady = '1';
        const dateInput = root.querySelector('[data-appointment-date]');
        const start = root.querySelector('[data-appointment-start]');
        const end = root.querySelector('[data-appointment-end]');
        let endPicked = false;

        const { initialStartsAt, initialEndsAt } = root.dataset;
        if (initialStartsAt) {
            const startsAt = new Date(initialStartsAt);
            const endsAt = new Date(initialEndsAt);
            if (!Number.isNaN(startsAt.getTime())) {
                dateInput.value = isoDate(startsAt);
                selectTime(start, `${pad(startsAt.getHours())}:${pad(startsAt.getMinutes())}`);
            }
            if (!Number.isNaN(endsAt.getTime())) {
                selectTime(end, `${pad(endsAt.getHours())}:${pad(endsAt.getMinutes())}`);
                endPicked = true;
            }
        } else {
            if (root.dataset.initialDate) dateInput.value = root.dataset.initialDate;
            selectTime(start, root.dataset.initialStart);
            selectTime(end, root.dataset.initialEnd);
            endPicked = Boolean(root.dataset.initialEnd);
        }
        syncChips(root);
        syncEnd(root, { followStart: false });

        root.querySelectorAll('[data-appointment-date-offset]').forEach((chip) => {
            chip.addEventListener('click', () => {
                dateInput.value = quickDate(chip);
                syncChips(root);
            });
        });
        dateInput.addEventListener('input', () => syncChips(root));
        start.addEventListener('change', () => syncEnd(root, { followStart: !endPicked }));
        end.addEventListener('change', () => { endPicked = Boolean(end.value); });
    }

    function onReady(event) {
        const scope = event && event.target && event.target.querySelectorAll ? event.target : document;
        if (scope.matches && scope.matches('[data-appointment-time-fields]')) init(scope);
        scope.querySelectorAll('[data-appointment-time-fields]').forEach(init);
    }

    document.addEventListener('DOMContentLoaded', () => onReady({ target: document }));
    document.body.addEventListener('sheet:ready', onReady);
    document.body.addEventListener('htmx:afterSettle', onReady);
    document.body.addEventListener('htmx:load', onReady);
}());
